import React from "react";

import ReactDOM from "react-dom";
import App from "./App";

// We need to load our index.scss file in development because we don't want to have to
// call out to the branding service for a specific sha that may not exist while developing
if (import.meta.env.DEV) {
  await import("./_styles/index.scss");
}

ReactDOM.render(<App />, document.getElementById("root"));
